module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path.indexOf('/openLogin') === 0) ? _c('div', [_c('router-view')], 1) : _c('div', {
    attrs: {
      "id": "viewPort"
    }
  }, [_c('Header', {
    attrs: {
      "onLogin": _vm.showLoginModal
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "onLogin": _vm.showLoginModal
    }
  })], 1), _vm._v(" "), _c('modal-login', {
    ref: "loginModal"
  }), _vm._v(" "), _c('update-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c37ce290"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Portal.vue
// module id = 1385
// module chunks = 26